import { Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Feedback from 'modules/nps/components/Feedback'
import Scoring from 'modules/nps/components/Scoring'
import Wrapper from 'modules/nps/components/Widget/_Wrapper'

import { ReviewButton } from './ReviewButton'
import { FeedbackStepProps, ScoringStepProps, ThankYouStepProps } from './types'

export const _ScoringStep = ({
  onCompleteStep,
  onChangeValue,
  variant,
  moduleName,
  icon,
  onClose,
}: ScoringStepProps) => {
  return (
    <Wrapper
      title={i18n.t('nps.widget.title.score_step', { moduleName })}
      variant={variant}
      icon={icon}
      onClose={onClose}
    >
      <Scoring
        onChange={(scoring) => {
          onChangeValue(scoring)
          if (!!scoring) {
            onCompleteStep()
          }
        }}
        variant={variant}
      />
    </Wrapper>
  )
}

export const _FeedbackStep = ({
  onCompleteStep,
  onChangeValue,
  variant,
  isDetractor,
  icon,
  onClose,
  currentValue,
  isSubmitting,
}: FeedbackStepProps) => {
  return (
    <Wrapper
      title={
        isDetractor
          ? i18n.t('nps.widget.title.feedback_step.negative')
          : i18n.t('nps.widget.title.feedback_step.positive')
      }
      variant={variant}
      icon={icon}
      onClose={onClose}
    >
      <Feedback
        onChange={(e) => onChangeValue(e)}
        onSubmit={onCompleteStep}
        currentValue={currentValue}
        isSubmitting={isSubmitting}
      />
    </Wrapper>
  )
}

export const _ThankYouStep = ({ onClose, scoring }: ThankYouStepProps) => {
  return (
    <Wrapper
      title={i18n.t('nps.widget.title.thanks_step')}
      variant="viridian"
      icon="check"
      iconColor="viridian1000"
      onClose={onClose}
    >
      {scoring && scoring >= 9 ? (
        <ReviewButton onClose={onClose} />
      ) : (
        <Text size="300" color="grey1000">
          {i18n.t('nps.widget.thank_you_message')}
        </Text>
      )}
    </Wrapper>
  )
}
